import React from 'react';
import PropTypes from 'prop-types';
import { Form, Dropdown, Checkbox, Radio } from 'semantic-ui-react';

export const renderDropdown = ({
  input,
  options,
  placeholder,
  label,
  required,
  meta: { touched, error },
}) => (
  <Form.Field error={touched && error}>
    <label>
      {label}
      {required && <span style={{ color: 'red' }}> *</span>}
    </label>
    <Dropdown
      {...input}
      onChange={(e, { value }) => input.onChange(value)}
      value={input.value}
      options={options}
      selection
      fluid
      placeholder={placeholder}
    />
    {touched && error && (
      <span style={{ color: 'red', fontSize: '0.9em' }}>{error}</span>
    )}
  </Form.Field>
);

renderDropdown.propTypes = {
  input: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
};

renderDropdown.defaultProps = {
  placeholder: '',
  required: false,
};

export const renderRadioGroup = ({ input, label, options }) => (
  <Form.Field>
    <label>{label}</label>
    {options.map(option => (
      <div key={option.value} style={{ marginBottom: '0.5em' }}>
        <Radio
          label={option.label}
          checked={input.value === option.value}
          onChange={() => input.onChange(option.value)}
        />
      </div>
    ))}
  </Form.Field>
);

renderRadioGroup.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};

export const renderCheckboxGrid = ({
  input,
  label,
  options,
  meta: { touched, error },
}) => (
  <Form.Field error={touched && error}>
    {label && (
      <label>
        {label} <span style={{ color: 'red' }}>*</span>
      </label>
    )}
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '0.5em',
      }}
    >
      {options.map(option => (
        <Checkbox
          key={option.value}
          label={option.label}
          checked={input.value && input.value.includes(option.value)}
          onChange={(e, { checked }) => {
            const newValue = [...(input.value || [])];
            if (checked) {
              newValue.push(option.value);
            } else {
              const index = newValue.indexOf(option.value);
              newValue.splice(index, 1);
            }
            input.onChange(newValue);
          }}
        />
      ))}
    </div>
    {touched && error && (
      <div style={{ color: 'red', fontSize: '0.9em', marginTop: '0.5em' }}>
        {error}
      </div>
    )}
  </Form.Field>
);

renderCheckboxGrid.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
};

renderCheckboxGrid.defaultProps = {
  label: '',
};
